export default function About() {
  return (
    <div className="content-container">
      <h1>
        Practices
      </h1>
      <div className="content-text">
        <p>
          Having worked as a developer, tech lead, product owner, and product manager for over a decade, I've collaborated
          with diverse teams and experienced a variety of working styles. Along the way, I've had the privilege of
          meeting many talented and inspiring people who have enriched both my professional and personal life.
        </p>
        <p>
          What consistently stood out to me is that the teams who deliver high-quality products, have an open mind,
          embrace new challenges, and maintain a mindset of continuous learning. To me, this is how great teams scale.
        </p>
        <p>
          I strive to embody these habits and values in my daily work. Below is a selection of practices I try to follow.
        </p>
        <div>
          <h2>Product & Strategy</h2>
          <ul>
            <li>Understand your users: Dig beyond surface needs and always validate your assumptions</li>
            <li>Learn fast: Use MVPs, PoCs, and experiments to iterate quickly</li>
            <li>Manage your time: Understand the difference between urgency and importance</li>
            <li>It's all about change: Building great products isn't enough. You also need to integrate it into the company's culture.</li>
            <li>Make decisions based on data, not assumptions</li>
          </ul>

        </div>
        <div>
          <h2>Leadership</h2>
          <ul>
            <li>Foster autonomy: Trust your team to know what needs to be done</li>
            <li>Know what your team needs and don't be afraid to get your hands dirty</li>
            <li>Don't avoid difficult conversations: Always provide honest and kind feedback</li>
            <li>Trust drives performance: A team should feel safe to take risks and make mistakes</li>
          </ul>
        </div>
        <div>
          <h2>Development</h2>
          <ul>
            <li>Build testability into your code from the start and apply test-driven development</li>
            <li>Write adaptable code: Good code is easy to change and easy to test</li>
            <li>Fix broken windows: Deliver products that’s “good enough”, but address poor design, bad decisions, and weak code immediately</li>
            <li>Invest in automation: Strong tooling helps you and your team scale</li>
          </ul>
        </div>
      </div>
    </div>
  )};